import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const TableWrapper = styled('section')`
  padding-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const SecondaryText = styled.span`
  color: ${({ theme }) => theme.color.whiteRGBA(0.7)};
`;

export const NoDataText = styled.span`
  color: ${({ theme }) => theme.color.whiteRGBA(0.3)};
`;

export const SectionIcon = styled.section`
  display: flex;
  align-items: baseline;
  > button {
    top: -5px;
    margin: 0 -${({ theme }) => theme.x1spacePx}px;
    padding-left: ${({ theme }) => theme.x4spacePx}px;
  }
  ${media.mdUp`
    > button {
      top: -2px;
      margin: 0;
      padding-left: 3px;
    }
  `};

  > button > svg {
    fill: ${({ theme }) => theme.color.brand01};
    opacity: 1;
  }
`;

export const SectionRow = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
